import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionCredentialsService } from '@core/services/session-credentials/session-credentials.service';

/**
 * Attaches the anymatch session credentials (`X-Session-Id` + `X-Session-Pin`) to
 * every public API call, so the pin-guarded backend (`REQUIRE_SESSION_PIN=true`)
 * accepts the request. No-op for non-public requests and when no pin was supplied.
 */
@Injectable()
export class SessionPinInterceptor implements HttpInterceptor {
  private creds = inject(SessionCredentialsService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes('/public/')) {
      return next.handle(request);
    }

    this.creds.captureFromUrl();
    const id = this.creds.id;
    const pin = this.creds.sessionPin;

    if (id && pin) {
      request = request.clone({
        setHeaders: { 'X-Session-Id': id, 'X-Session-Pin': pin },
      });
    }

    return next.handle(request);
  }
}
